import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { MessageType as BasicMessageType } from 'types/message'

type MessageType = BasicMessageType & { ref: FirebaseDocRefType }

const MessageConverter = getConverter<MessageType>()

export const fetchCustomerMessages = (storeRef: FirebaseDocRefType): Promise<MessageType[]> => {
  return db
    .collection('messages')
    .withConverter(MessageConverter)
    .where('channel', '==', 'bread/store')
    .where('store_ref', '==', storeRef)
    .orderBy('created_at', 'desc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const fetchCustomerMessage = (id: string): Promise<MessageType | undefined> => {
  return db
    .collection('messages')
    .doc(id)
    .withConverter(MessageConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchAdminMessages = (): Promise<MessageType[]> => {
  return db
    .collection('messages')
    .withConverter(MessageConverter)
    .where('channel', '==', 'sacri')
    .orderBy('created_at', 'desc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data()
        return {
          ...data,
          ref: snapshot.ref,
        }
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}
